import { InfoField } from "@/components/InfoField";
import { Skeleton } from "@/components/ui/skeleton";

export function BookingSkeleton({ numItems, ...props }: { numItems: number; "aria-label": string }) {
  const skeletonInfo = [...Array(numItems).keys()];

  // Define which items should be full-width based on the actual booking layout
  // Items 6 (Note), 7 (Source), and 8 (Destination) are potentially full-width
  // We assume full-width during loading to prevent layout shift when content loads
  const isFullWidth = (index: number) => index >= 6;

  return (
    <div role="status" aria-busy="true" aria-label={props["aria-label"]} className="contents">
      {skeletonInfo.map((num, index) => (
        <InfoField key={num} fullWidth={isFullWidth(index)}>
          <Skeleton className="h-4 w-24" />
          <Skeleton className={isFullWidth(index) ? "h-5 w-48" : "h-5 w-32"} />
        </InfoField>
      ))}
    </div>
  );
}
